import { Component } from '@angular/core';
import {
  IconDynamicColors,
  IconDynamicData,
  IconDynamicHeadsetComponent,
  omniConfig,
  CommChannelContent,
} from '@cigna/omni/shared-util';
import { OmniCommChannelFacade } from '../+state/comm-channel.facade';
import { map } from 'rxjs/operators';

@Component({
  selector: 'cigna-omni-comm-channel-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class CommChannelSupportComponent {
  public content$ = this.commChannelFacade.supportContent$.pipe(
    map((content) => {
      if (content.icon) {
        return { ...content, icon: IconDynamicHeadsetComponent };
      }
      return content;
    }),
  );

  public iconColors: IconDynamicColors = {
    color: omniConfig.omniColors.gray60,
  };
  public iconData: IconDynamicData = {
    size: '46px',
  };

  constructor(private commChannelFacade: OmniCommChannelFacade) {}

  public interact(content: CommChannelContent) {
    this.commChannelFacade.interact(content, { tags: ['support'] });
  }
}
